import React, {useEffect, useState} from 'react';

import {ReactComponent as BackIcon} from '../../assests/back-icon.svg';
import './searchAndFilters.scss';
import getIcon from '../../config/iconToCategoryMap';
import {Route, Switch, useHistory} from 'react-router-dom';
import {createAnalyticsEvent} from '../../firebase/firebase'


export default function SearchAndFilters(props) {
    const history = useHistory();

    const {totalLength, searchText, setSearchText, categories = [], setFilterCategory, professionals, filterCategory} = props;

    const onSearchTextChanged = (event)=>{
        setSearchText(event.target.value);
        createAnalyticsEvent({eventName: 'search', eventParams: {text: event.target.value}});

    }

    const onCategoryClicked = (category)=>{
        if(!category){
            console.error('[onCategoryClicked] but category is empty!');
            return;
        }

        createAnalyticsEvent({eventName: 'category-clicked', eventParams: {name: category}});

        setFilterCategory(category);

        history.push(`/home/welcome/${category}`);
    }

    return (
        <div className={'search-and-filters-container'}>
            <input className={'search-input'} value={searchText} onChange={onSearchTextChanged} placeholder={'חיפוש חופשי: שם / מקצוע'} />
            {totalLength ? <div className={'total-results'}>סה״כ תוצאות:{totalLength}</div> :
                (searchText ?
                    (filterCategory ? <div className={'no-results-where-found'}><span>לא נמצאו תוצאות בקטגוריית {filterCategory}</span></div> :
                        <div className={'no-results-where-found'}><span>ללא נמצאו תוצאות, נסו חיפוש אחר</span></div>)
                    : <div className={'no-results'}><span>הקלד על החיפוש או בחר קטגוריות</span></div>)}

            <Switch>
                <Route path="/home/welcome" exact render={({match})=>{
                    setFilterCategory(null);
                    let categoriesToRender = categories;
                    if(searchText){
                        const map = {};
                        professionals.forEach(professional=>{
                            if(!map[professional.category]) map[professional.category] = true;
                        });
                        categoriesToRender = Object.keys(map);
                    }
                    if(categoriesToRender.length === 0) return null;
                    return  <div className={'categories-filter-container'}>
                        {categoriesToRender.map(category=>{
                            return <div className={'button-category'}
                                onClick={()=>onCategoryClicked(category)}
                                id={category}
                                key={`category-${category}`}>
                                {getIcon(category)}
                                <div className={'button-category-name'}>{category}</div>
                            </div>
                        })}
                    </div>
                }}/>
                <Route path="/home/welcome/:category" render={({match})=>{
                    const { category } = match.params;
                    if(categories.length > 0 && !categories.includes(category)){
                        history.push(`/home/welcome`);
                        return;
                    }
                    setFilterCategory(category);
                    return  <div className={'category-chosen-container'}>
                        {getIcon(category)}
                        <div className={'category-chosen-name'}>{category}</div>
                        <BackIcon onClick={()=>{
                            history.push(`/home/welcome`);
                        }}/>
                    </div>
                }}/>
            </Switch>
        </div>
    );
}